import { SubscriptionName } from '@anm/api/modules/subscription';

const getDisplayPlanName = (subscriptionName: SubscriptionName) => {
  switch (true) {
    case subscriptionName.includes('Free'):
      return 'Free';

    case subscriptionName.includes('Creator'):
      return 'Creator';

    case subscriptionName.includes('Ultimate'):
      return 'Ultimate';

    case subscriptionName.includes('Agency'):
      return 'Agency';

    case subscriptionName.includes('Pro'):
      return 'Pro';

    case subscriptionName.includes('Corporate'):
      return 'Corporate';

    case subscriptionName.includes('Staff'):
      return 'Staff';

    case subscriptionName.includes('Influencer'):
      return 'Influencer';

    case subscriptionName.includes('Business'):
      return 'Business';

    case subscriptionName.includes('Enterprise'):
      return 'Enterprise';

    default:
      return subscriptionName as string;
  }
};

export default getDisplayPlanName;
